"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowALeftIcon20Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowALeftIcon20Regular = forwardRef_1.forwardRef('ArrowALeftIcon20Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M8.812 16.032a.75.75 0 1 1-1.06 1.06l-5.238-5.236a2.625 2.625 0 0 1 0-3.712l5.237-5.237a.75.75 0 1 1 1.06 1.06L3.576 9.205c-.015.015-.03.03-.043.046H17.5a.75.75 0 0 1 0 1.5H3.532l.043.045 5.237 5.237Z" })));
});
